<template>
  <div>
    <ConsentTerm ref="ConsentTerm" v-if="showTerm"/>
    <Add ref="Add" v-if="showAdd"/>
    <DetailsHeader ref="DetailsHeader" v-if="showDetails" v-on:SectionApproval="onSectionApproval" v-on:Approval="onApproval" v-on:Disapproval="onDisapproval"/>
    <Tables ref="tableGrid" v-if="showDetails"
            :columns="[
              '',
              'Data',
              'Descrição',
              'Observações',
              'Tipo',
              'Quantidade',
              'Valor',
              'Total',
              'Saldo',
              'Comprovante']"
            :showSearch="false"
            :showPrint="false"
            :showDownload="false"
            :showFullscreen="false"
            v-on:Load="onLoad">
      <template slot="header-card-actions">
        <span>
          <a href="javascript:void(0);" v-b-tooltip.hover :title="'Nova Despesa'" @click="showModalDebt" v-if="this.objSelected != null && (this.objSelected.situacao === null || this.objSelected.situacao === 0)">
            <i class="fas fa-shopping-cart text-third"></i>
          </a>
          <a href="javascript:void(0);" v-b-tooltip.hover :title="'Novo Crédito'" @click="showModalCredit" v-if="this.objSelected != null && (this.objSelected.situacao === null || this.objSelected.situacao < 4)">
            <i class="fas fa-dollar sign text-third"></i>
          </a>
        </span>
      </template>
      <tr v-for="(obj, index) in this.objList" v-bind:key="index">
        <TableColumn :IsCustom="true" :status="obj.status">
          <b-form-checkbox :id="`cbxItem-${index}`" v-if="!obj.forma && !obj.incorrida  && (obj.despesa.situacao >= 1 && obj.despesa.situacao < 4)"
                           v-model="obj.checked"
                           :name="`cbxItem-${index}`"
                           :value="true"
                           size="sm" />
          <span v-if="obj.incorrida" class="text-left" v-b-tooltip.hover :title="obj.motivoIncorrida"><i class="fas fa-ban text-danger" style="font-size: 14px; font-weight: bold;"></i></span>
        </TableColumn>
        <TableColumn :IsDateOnly="true" v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.dataDespesa" :IsLineThrough="obj.incorrida" />
        <TableColumn :IsText="true" v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.despesaTipo ? obj.despesaTipo.nome : ''" :IsLineThrough="obj.incorrida" />
        <TableColumn :IsCustom="true" class="text-center">
          <span v-if="obj.observacao" v-b-tooltip.hover :title="obj.observacao"><i class="fas fa-comment-alt" style="font-size: 15px; color: #4d7da3;"></i></span>
          <span>&nbsp;</span>
        </TableColumn>
        <TableColumn :IsCustom="true" v-on:Edit="onSelect(obj)" :status="obj.status">
          <span v-if="obj.forma" class="text-credit text-toupper" :style="obj.incorrida ? 'text-decoration: line-through': ''"><strong>C</strong></span>
          <span v-else class="text-danger text-toupper" :style="obj.incorrida ? 'text-decoration: line-through': ''"><strong>D</strong></span>
        </TableColumn>
        <TableColumn :IsText="true" v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.quantidade.toString()" :IsLineThrough="obj.incorrida" />
        <TableColumn :IsCustom="true" v-on:Edit="onSelect(obj)" :status="obj.status">
          <span v-if="obj.forma" class="text-credit text-toupper" :style="obj.incorrida ? 'text-decoration: line-through': ''">{{formatMoney(obj.valorUnitario)}}</span>
          <span v-else class="text-danger text-toupper" :style="obj.incorrida ? 'text-decoration: line-through': ''">{{formatMoney(obj.valorUnitario)}}</span>
        </TableColumn>
        <TableColumn :IsText="true" v-on:Edit="onSelect(obj)" :status="obj.status" :value="formatMoney(obj.valorTotal)" :IsLineThrough="obj.incorrida" />
        <TableColumn :IsCustom="true" v-on:Edit="onSelect(obj)" :status="obj.status">
          <span v-if="obj.saldo >= 0" class="text-credit text-toupper" :style="obj.incorrida ? 'text-decoration: line-through': ''">{{formatMoney(obj.saldo)}}</span>
          <span v-else class="text-danger text-toupper" :style="obj.incorrida ? 'text-decoration: line-through': ''">{{formatMoney(obj.saldo)}}</span>
        </TableColumn>
        <TableColumn :IsCustom="true" v-on:Edit="onSelect(obj)" :status="obj.status">
          <img v-if="obj.arquivoNome" src="/static/img/comprovante_despesa.jpg" alt="Comprovante" style="width: 25px;">
          <span v-else>&nbsp;</span>
        </TableColumn>
      </tr>
      <template slot="tfoot">
        <tr style="background-color: #fafafa;">
          <td colspan="8" class="text-right"><strong> Saldo Final </strong></td>
          <td v-if="totalBalance >= 0" class="text-center text-bold" style="color: #008144;"><strong>{{formatMoney(totalBalance)}}</strong></td>
          <td v-else class="text-center text-bold text-danger"><strong>{{formatMoney(totalBalance)}}</strong></td>
          <td class="text-center">&nbsp;</td>
        </tr>
      </template>
      <template slot="footer">
        <div class="form-group row pt-4">
          <div class="col-md-12 pl-3">
            <button type="button" class="btn btn-default btn-sm btn-third mr-1" v-b-tooltip.hover title="Clique para Lançar Despesas" @click="showModalDebt" :disabled="this.objSelected != null ? false : true" v-if="this.objSelected != null && (this.objSelected.situacao === null || this.objSelected.situacao === 0)"><i class="fas fa-shopping-cart"></i> Nova Despesa</button>
            <button type="button" class="btn btn-danger btn-sm mr-1" v-b-tooltip.hover title="Clique para Reprovar Item" @click="showModalDisapproved" :disabled="this.objList ? false : true" v-if="this.objSelected != null && (this.objSelected.situacao >= 1 && this.objSelected.situacao < 4)"><i class="fas fa-times-circle"></i> Reprovar Item</button>
          </div>
        </div>
      </template>
    </Tables>
    <ModalDebt ref="ModalDebt" v-on:Reload="setReload"/>
    <ModalCredit ref="ModalCredit" v-on:Reload="setReload"/>
    <ModalDisapproved ref="ModalDisapproved" v-on:Reload="setReload" />
  </div>
</template>
<script>
import MiscellaneousExpenseDetails from './details.js'
export default MiscellaneousExpenseDetails
</script>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/miscellaneous/details/details.vue